import React from "react";

const TextBoxCanvas = (props) => {
  return <div>Hello from TextBoxCanvas</div>;
};

export default TextBoxCanvas;
